<template>
	<div style="width:100%;">
		<a-layout>
		      <a-layout-header style="padding: 0;">
				  <div id="headerDiv">
					  <div style="width: 55%;padding-left: 2.0rem;">
						  <a href="http://www.xcxdtech.com/" target="_blank">
							  <img src="../assets/logo.png" style="width: auto; height:4rem;"/>
						  </a>
					  </div>
					   <div id="headerContentDiv">
						   <a-button v-if="adminUserId == 223||adminUserId==256" type="link" icon="audit" size="large" style="color:white" @click="showUpdateMeterOKView"></a-button>
						   <a-tooltip  title="退出登录" placement="topLeft" arrowPointAtCenter>
							   <a-button type="link" icon="poweroff" size="large" style="color:white" @click="logout"></a-button>
						   </a-tooltip>
						   <a-tooltip title="查看集中器上下线日志" placement="topLeft" arrowPointAtCenter>
							   <a-button type="link" icon="pic-left" size="large" style="color:white" @click="showGprsLog"></a-button>
						   </a-tooltip>
						   <a-tooltip  title="今日抄表记录" placement="topLeft" arrowPointAtCenter>
							   <a-button type="link" icon="message" size="large" style="color:white" @click="showTaskDetail"></a-button>
						   </a-tooltip>
						   <span style=" color:white;font-weight: bold;font-size: 1rem;margin-right: 1.25rem;">欢迎你,{{adminUserName}}</span>
					   </div>
				  </div>
			  </a-layout-header>
		      <a-layout-content>
				   <a-layout style="height: calc(100vh - 64px)">
					   <a-layout-sider style="background-color: #ffffff;" width="140"  collapsible v-model="collapsed">
							  <a-menu mode="inline" theme="light" :style="{ borderRight: 0 }"
											@openChange="onOpenChange" :open-keys="openKeys">
									<a-sub-menu v-for="(item,index) in userMenus" :key="item.AuthorityCode">
										<span slot="title"><a-icon :type="item.icon"  :style="{color:'#000',fontSize:'16px'}"/>
											<span class="menuItem">{{item.Remark}}</span>
										</span>
										<a-menu-item v-for="(subItem,i) in item.subList" @click="clickMenu(subItem)" :key="subItem.AuthorityCode">
											<a-tooltip placement="bottomLeft" arrowPointAtCenter>
												 <template slot="title">
													{{subItem.Remark}}
												</template>
												<span class="subMenuItem">{{subItem.Remark}}</span>
											</a-tooltip>
										</a-menu-item>
									</a-sub-menu>
							  </a-menu>
					   </a-layout-sider>
					    <a-layout-content style="background-color: #ffffff; margin-left: 0.3rem;">
							<div id="contentDiv">
								<a-tabs v-model="activeTabKey" type="editable-card" :tabBarGutter="5" :hideAdd="true" 
								size="small" @edit="onEdit" @tabClick="tabClick">
									<a-tab-pane v-for="(item) in tabPanes" :closable="item.closeFlag" :tab="item.title" :key="item.key">
										<div :is="item.component" :ref="item.key" @parentMethod="parentMethod"></div>
									</a-tab-pane>
								</a-tabs>
							</div>
							<a-modal title="数据修正" :visible="showUpdateFlag" :confirmLoading="updateLoading"
											@ok="doUpdateMeter" @cancel="showUpdateFlag = false" :width="640">
								<div style="color: red;font-size: 0.75rem;margin: 0.625rem 0;">将选中的小区下所有水表状态改为正常(支持多选)</div>
								<a-select  style="margin-bottom: 0.625rem;font-size: 0.6875rem;width: 100%;" v-model="theNeighbor" option-filter-prop="children"  :filter-option="filterOption" show-search
									:allowClear="true" mode="multiple" placeholder="选择小区" @change="handleChange">
									<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
								</a-select>
							</a-modal>
							<vxe-modal ref="mModal" v-model="showGprsOnLineLogFlag" title="集中器上下线日志" width="800" height="600"
													resize destroy-on-close :mask="true" position="center">
									<ShowGprsOnLineLog/>
							</vxe-modal>
					     </a-layout-content>
				   </a-layout>
			  </a-layout-content>
		 </a-layout>
	</div>
</template>
<script>
	import Welcome from '../components/Welcome.vue'
	import WaterCompanyManage from '/src/views/WaterCompanyManage.vue'
	import AuthorityManage from '/src/views/AuthorityManage.vue' 
	import UserAdminManage from '/src/views/UserAdminManage.vue'
	import DepartAreaManage from '/src/views/DepartAreaManage.vue'
	import BasicPriceManage from '/src/views/BasicPriceManage.vue'
	import FailureNoticeManage from '/src/views/FailureNoticeManage.vue'
	import ChargeRemindManage from '/src/views/ChargeRemindManage.vue'
	import NeighborManage from '/src/views/NeighborManage.vue'
	import CustomerManage from '/src/views/CustomerManage.vue'
	import ReadMeterManage from '/src/views/ReadMeterManage.vue'
	import ShowTaskDetail from '/src/components/ShowTaskDetail.vue'
	import ShowReadMeterResultAll from '/src/components/ShowReadMeterResultAll.vue'
	import ReadResultAnalysis from '/src/views/ReadResultAnalysis.vue'
	import UnRemoteRead from '/src/views/UnRemoteRead.vue'
	import ChargeManage from '/src/views/ChargeManage.vue'
	import SettleManage from '/src/views/SettleManage.vue'
	import PrePaySignManage from '/src/views/PrePaySignManage.vue'
	//短信发送记录
	import SmsLogsStatisManage from '/src/views/SmsLogsStatisManage.vue'
	
	import BuildingStatisManage from '/src/views/BuildingStatisManage.vue'
	import ChargeStatisManage from '/src/views/ChargeStatisManage.vue'
	import ChargePercentStatisManage from '/src/views/ChargePercentStatisManage.vue'
	import DeductStatisManage from '/src/views/DeductStatisManage.vue'
	import NoChangeStatisManage from '/src/views/NoChangeStatisManage.vue'
	import OweStatisManage from '/src/views/OweStatisManage.vue'
	import UnChargeStatisManage from '/src/views/UnChargeStatisManage.vue'
	import UndoStatisManage from '/src/views/UndoStatisManage.vue'
	import UseStatisManage from '/src/views/UseStatisManage.vue'
	import VIPStatisManage from '/src/views/VIPStatisManage.vue'
	import WasteStatisManage from '/src/views/WasteStatisManage.vue'
	import LargeUseStatisManage from '/src/views/LargeUseStatisManage.vue'
	import LastestNeighborList from '/src/views/LastestNeighborList.vue'
	import LihuFailMetermanage from '/src/views/LihuFailMetermanage.vue'
	import ShowGprsOnLineLog from '/src/components/ShowGprsOnLineLog.vue'
	import NewUseStatisManage from '/src/views/NewUseStatisManage.vue'
	import ReconnectingWebSocket from 'reconnecting-websocket';
	import MinusStatisManage from '/src/views/MinusStatisManage.vue'
	import NBCollectorManage from '/src/views/NBCollectorManage.vue'
	import ElecMeterManage from '/src/views/ElecMeterManage.vue'
	import UseCountManage from '/src/views/UseCountManage.vue'
	import MeterMonitorManage from '/src/views/MeterMonitorManage.vue'
	import MeterMonitorStatis from '/src/views/MeterMonitorStatis.vue'
	import CommonManage from '/src/views/CommonManage.vue'
	import MeterMonitorInfo from '/src/views/MeterMonitorInfo.vue'
	import MeterChangeStatis from '/src/views/MeterChangeStatis.vue'
	export default{
		components:{
			Welcome,
			WaterCompanyManage,
			AuthorityManage,
			UserAdminManage,
			DepartAreaManage,
			BasicPriceManage,
			FailureNoticeManage,
			ChargeRemindManage,
			NeighborManage,
			CustomerManage,
			ReadMeterManage,
			ShowTaskDetail,
			ShowReadMeterResultAll,
			ReadResultAnalysis,
			UnRemoteRead,
			ChargeManage,
			SettleManage,
			PrePaySignManage,
			//短信发送记录
			SmsLogsStatisManage,
			BuildingStatisManage,
			ChargeStatisManage,
			ChargePercentStatisManage,
			DeductStatisManage,
			OweStatisManage,
			NoChangeStatisManage,
			UnChargeStatisManage,
			UndoStatisManage,
			UseStatisManage,
			VIPStatisManage,
			WasteStatisManage,
			LargeUseStatisManage,
			LastestNeighborList,
			LihuFailMetermanage,
			ShowGprsOnLineLog,
			NewUseStatisManage,
			MinusStatisManage,
			NBCollectorManage,
			ElecMeterManage,
			UseCountManage,
			MeterMonitorManage,
			MeterMonitorStatis,
			CommonManage,
			MeterMonitorInfo,
			MeterChangeStatis
		},
		data(){
			const tabPanes = [
				{title: '首页', key: 'welcome', component: 'Welcome',closeFlag: false}
			 ];
			return{
				adminUserName:'',
				adminUserId:1,
				themodal:null,
				userMenus:[],
				openKeys:[],
				tabPanes,
				activeTabKey:tabPanes[0].key,
				showMessage:false,
				collapsed:false,
				showUpdateFlag:false,
				updateLoading:false,
				neighborList:[],
				theNeighbor:undefined,
				selectedNeihgbors:[],
				showGprsOnLineLogFlag:false,
				webSocket:null,
			}
		},
		methods:{
			showGprsLog:function(){
				this.showGprsOnLineLogFlag = true;
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			handleChange:function(value){
				this.selectedNeihgbors = value;
			},
			showUpdateMeterOKView:function(){
				this.showUpdateFlag = true;
				this.selectedNeihgbors = [];
				this.theNeighbor = undefined;
			},
			doUpdateMeter:function(){
				this.updateLoading = true;
				let neighborIds = this.selectedNeihgbors.join(",");
				let param = {neighborIds:neighborIds};
				let url = this.Api.getLastUrl(this.Api.READ_METER_UPDATE_METER_OK_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.updateLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						let newMsg = "已修改数据"+result+"条"
						this.$message.success(newMsg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.updateLoading = false;
					console.log(error);
				});
			},
			toggleCollapsed:function(){
				this.collapsed = !this.collapsed;
			},
			parentMethod:function(param){
				if(param[0] == 'welcome'){
					this.gotoNeighbor();
				}
			},
			refreshReadMeter:function(){
				if(this.$refs.readmeter[0] !=undefined){
					this.$refs.readmeter[0].queryListData();
					this.$refs.readmeter[0].allFlag = false;
					this.$refs.readmeter[0].canFinishFlag = false;
				}
			},
			refreshOneMeter:function(taskId){
				if(this.$refs.readmeter[0] !=undefined ){
					this.$refs.readmeter[0].refreshOneMeter(taskId);
				}
			},
			addAllResultTab:function(){
				if(this.$refs.readmeter[0] !=undefined){
					this.$refs.readmeter[0].checkAllLoading();
					this.$refs.readmeter[0].allFlag = false;
					this.$refs.readmeter[0].canFinishFlag = false;
				}
				if(type != 'error'){
					let component = 'ShowReadMeterResultAll';
					let title = '抄表结果';
					let key = 'ShowReadMeterResultAll';
					this.activeTabKey = key;
					if(this.existTabItem(key) == false){
						let newTabItem = this.createTabItem(title,component,key);
						const panes = this.tabPanes;
						panes.push(newTabItem);
						this.tabPanes  = panes;
					}
				}
			},
			logout:function(){
				this.themodal = this.$confirm({
					title:'确定要退出登录吗?',
					content:'',
					okType: 'warning',
					centered:true,
					onOk: h=>{
						this.doLogout();
					},
				});
			},
			doLogout:function(){
				this.themodal.destroy();
				let url = this.Api.getLastUrl(this.Api.USER_LOGOUT_URL);
				this.Api.fetchPost(url).then((data)=>{
					this.Config.removeUserInfo();
					this.Config.goHome();
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_NEIGHBORS_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			gotoNeighbor:function(){
				let component = 'LastestNeighborList';
				let title = '30天新增小区';
				let key = 'LastestNeighborList';
				this.activeTabKey = key;
				if(this.existTabItem(key) == false){
					let newTabItem = this.createTabItem(title,component,key);
					const panes = this.tabPanes;
					panes.push(newTabItem);
					this.tabPanes  = panes;
				}
			},
			showTaskDetail:function(){
				let component = 'ShowTaskDetail';
				let title = '任务详情';
				let key = 'ShowTaskDetail';
				this.activeTabKey = key;
				if(this.existTabItem(key) == false){
					let newTabItem = this.createTabItem(title,component,key);
					const panes = this.tabPanes;
					panes.push(newTabItem);
					this.tabPanes  = panes;
				}
			},
			getUserMenu:function(){
				let url = this.Api.getLastUrl(this.Api.USER_MENUS_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.userMenus = result;
						this.openKeys[0] = this.userMenus[0].AuthorityCode;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			onOpenChange:function(openKeys){
				if(openKeys.length == 0){
					this.openKeys = [];
				}else{
					if(openKeys.length == 1){
						this.openKeys = openKeys;
					}else{
						this.openKeys[0] = openKeys[1];
					}
				}
			},
			clickMenu:function(theMenu){
				let component = theMenu.ActUrl;
				let title = theMenu.Remark;
				let key = theMenu.AuthorityCode;
				this.activeTabKey = key;
				if(this.existTabItem(key) == false){
					let newTabItem = this.createTabItem(title,component,key);
					const panes = this.tabPanes;
					panes.push(newTabItem);
					this.tabPanes  = panes;
				}
			},
			createTabItem:function(title,component,key){
				return {
					title:title,
					key:key,
					component:component,
					closeFlag:true
				}
			},
			existTabItem:function(key){
				for(var i = 0;i<this.tabPanes.length;i++){
					let item = this.tabPanes[i];
					if(item.key == key){
						return true;
					}
				}
				return false;
			},
			onEdit(targetKey, action) {
				if(action == 'remove'){
					let index = this.getTheTabIndex(targetKey);
					if(index == this.tabPanes.length-1){
						this.activeTabKey =  this.tabPanes[this.tabPanes.length-2].key;
					}else{
						let activeTabIndex = this.getTheTabIndex(this.activeTabKey);
						if(index == activeTabIndex){
							this.activeTabKey = this.tabPanes[index+1].key;
						}
					}
					this.tabPanes.splice(index,1);
					if(this.activeTabKey == 'readmeter'){
						if(this.$refs.readmeter[0] !=undefined){
							this.$refs.readmeter[0].scrollSome();
						}
					}else if(this.activeTabKey == 'settle'){
						if(this.$refs.settle[0] !=undefined){
							this.$refs.settle[0].scrollSome();
						}
					}else if(this.activeTabKey == 'chargestat'){
						if(this.$refs.chargestat[0] !=undefined){
							this.$refs.chargestat[0].scrollSome();
						}
					}else if(this.activeTabKey == 'settlelogstat'){
						if(this.$refs.settlelogstat[0] !=undefined){
							this.$refs.settlelogstat[0].scrollSome();
						}
					}else if(this.activeTabKey == 'owestat'){
						if(this.$refs.owestat[0] !=undefined){
							this.$refs.owestat[0].scrollSome();
						}
					}else if(this.activeTabKey == 'unremote'){
						if(this.$refs.unremote[0] !=undefined){
							this.$refs.unremote[0].scrollSome();
						}
					}else if(this.activeTabKey == 'readresultAnalysis'){
						if(this.$refs.readresultAnalysis[0] !=undefined){
							this.$refs.readresultAnalysis[0].scrollSome();
						}
					}else if(this.activeTabKey == 'loustat'){
						if(this.$refs.loustat[0] !=undefined){
							this.$refs.loustat[0].scrollSome();
						}
					}else if(this.activeTabKey == 'userinfo'){
						if(this.$refs.userinfo[0] !=undefined){
							this.$refs.userinfo[0].scrollSome();
						}
					}else if(this.activeTabKey == 'chargeratestat'){
						if(this.$refs.chargeratestat[0] !=undefined){
							this.$refs.chargeratestat[0].scrollSome();
						}
					}else if(this.activeTabKey == 'undorecord'){
						if(this.$refs.undorecord[0] !=undefined){
							this.$refs.undorecord[0].scrollSome();
						}
					}else if(this.activeTabKey == 'unchagrerecord'){
						if(this.$refs.unchagrerecord[0] !=undefined){
							this.$refs.unchagrerecord[0].scrollSome();
						}
					}
				}
			},
			getTheTabIndex:function(key){
				let index = 0;
				for(var i = 0;i<this.tabPanes.length;i++){
					let obj = this.tabPanes[i];
					if(obj.key == key){
						index = i;
						break;
					}
				}
				return index;
			},
			tabClick:function(e){
				if(e == 'readmeter'){
					if(this.$refs.readmeter[0] !=undefined){
						this.$refs.readmeter[0].scrollSome();
					}
				}else if(e == 'settle'){
					if(this.$refs.settle[0] !=undefined){
						this.$refs.settle[0].scrollSome();
					}
				}else if(e == 'chargestat'){
						if(this.$refs.chargestat[0] !=undefined){
							this.$refs.chargestat[0].scrollSome();
						}
				}else if(e == 'settlelogstat'){
						if(this.$refs.settlelogstat[0] !=undefined){
							this.$refs.settlelogstat[0].scrollSome();
						}
				}else if(e == 'owestat'){
						if(this.$refs.owestat[0] !=undefined){
							this.$refs.owestat[0].scrollSome();
						}
				}else if(e == 'unremote'){
					if(this.$refs.unremote[0] !=undefined){
						this.$refs.unremote[0].scrollSome();
					}
				}else if(e == 'readresultAnalysis'){
					if(this.$refs.readresultAnalysis[0] !=undefined){
						this.$refs.readresultAnalysis[0].scrollSome();
					}
				}else if(e == 'loustat'){
					if(this.$refs.loustat[0] !=undefined){
						this.$refs.loustat[0].scrollSome();
					}
				}else if(e == 'userinfo'){
					if(this.$refs.userinfo[0] !=undefined){
						this.$refs.userinfo[0].scrollSome();
					}
				}else if(e == 'chargeratestat'){
					if(this.$refs.chargeratestat[0] !=undefined){
						this.$refs.chargeratestat[0].scrollSome();
					}
				}else if(e == 'undorecord'){
					if(this.$refs.undorecord[0] !=undefined){
						this.$refs.undorecord[0].scrollSome();
					}
				}else if(e == 'unchagrerecord'){
					if(this.$refs.unchagrerecord[0] !=undefined){
						this.$refs.unchagrerecord[0].scrollSome();
					}
				}
				
			},
			showPatchAlert:function(content,taskId){
				this.themodal = this.$confirm({
					title:'提示',
					content:content,
					okText:'立即补抄',
					centered:true,
					onOk: h=>{
						this.createPatchTask(taskId);
					},
				});
			},
			showDLTAlert:function(content){
				 this.$message.success(content);
				 if(this.$refs.elecmeter[0] !=undefined){
				 	this.$refs.elecmeter[0].queryMeters();
				 }
			},
			createPatchTask:function(taskId){
				this.themodal.destroy();
				let url = this.Api.getLastUrl(this.Api.READ_METER_PATCH_TASK_URL);
				let param = {taskId:taskId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			startWebSocket:function(){
				let userId = this.Config.getUserLocal().pId;
				this.webSocket = new ReconnectingWebSocket(this.Api.WEBSOCKET_URL+userId);
				this.webSocket.onopen = function(){// 建立连接后触发的事件
					console.log("WebSocketConnected");
				};
				this.webSocket.onmessage = (evt)=>{ // 接收服务器消息
					let data  = JSON.parse(evt.data);
					let content = data.content;
					let title = data.title;
					let type = data.showType;
					let readType = data.readType;
					let result = data.resultList;
					const key = `open${Date.now()}`;
					if(readType != "patchTask" && readType!="DLTReadData"){
						this.$notification[type]({
							message:title,
							description:content,
							style: {
								whiteSpace: 'pre-wrap',
							},
							btn: h => {
								return h(
									'a-button',{
										props: {
											type: 'primary',
											size: 'small',
										},
										on: {
											click: () => {
												this.showTaskDetail();
												this.$notification.close(key);
											},
										},
									},
								'查看详情',
							  );
							},
							key,
						});
					}
					if(readType == "messageTypeReadAllNeighbor"){
						this.addAllResultTab(type);
					}else if(readType == "patchTask"){
						this.showPatchAlert(content,data.taskId);
					}else if(readType == "messageTypeReadMeters"){
						this.refreshOneMeter(data.taskId);
					}else if(readType == "DLTReadData"){
						this.showDLTAlert(content);
					}else{
						this.refreshReadMeter();
					}
				};
				this.webSocket.onclose = function(e) {// 关闭连接
					console.log('连接关闭的回调方法');
				};
				this.webSocket.onerror = function(evt) {// 连接异常
					console.log(evt+"WebSocketError"); 
				};
			}
		},
		created() {
			this.adminUserName  = this.Config.getUserLocal().adminName;
			this.adminUserId = this.Config.getUserLocal().pId;
			this.getUserMenu();
			this.startWebSocket();
			this.queryNeighbors();
		},
		destroyed() {
			console.log("destroyed");
			this.webSocket.close();
		},
		mounted() {
		}
	}
</script>
<style>
	#headerDiv{
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 100%;
		background-image: url(../assets/head.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	#headerContentDiv{
		width: 45%;
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
		padding-right: 0.625rem;
	}
	#contentDiv{
		overflow: hidden;
		padding:  0.15rem 0.3125rem;
	}
	.menuItem{
		font-size: 0.8125rem;
		color: #555;
		font-weight: bold;
	}
	.subMenuItem{
		color: #333;
		font-size: 0.7rem;
	}
</style>
